
import Layout from "./components/Layout";
import useIsDpcDoubled from "./utils/useIsDpcDoubled";
import Finish from "./components/Finish";
import { useEffect } from "react";
import DpcDouble from "./components/DpcDouble";
import LearnyDaysOffer from "./components/LearnyDaysOffer";
import useIsLearnyDays from "./utils/useIsLearnyDays";

export default function DpcSuccess() {
    const isDpcDoubled = useIsDpcDoubled();

    useEffect(() => {
        if (isDpcDoubled) {
            window.localStorage.removeItem('dpcDoubled');
        }
    }, [isDpcDoubled]);

    const isLearnyDays = useIsLearnyDays();

    if(isLearnyDays) {
        return (
            <Layout>
                <LearnyDaysOffer />
            </Layout>
        );
    }    

    return (
        <Layout> 
            {!isDpcDoubled && <DpcDouble />}
            {isDpcDoubled && <Finish />}
        </Layout>
    );
}


